module.exports = __webpack_public_path__ + "static/media/manual_06.33ba9c3f.jpg";